// extracted by mini-css-extract-plugin
export default {"container":"FAQ_container__pyaBx","faqContainer":"FAQ_faqContainer__8Zp29","divider":"FAQ_divider__fi4EN","card":"FAQ_card__tZ4iO"};